import { Box, Skeleton } from '@factorialco/deprecated-design-system'

const LoadingItem = () => {
  return (
    <Box gap="s24" flexDirection="row">
      <Skeleton width="s140" height="s8" />
      <Box gap="s8">
        <Skeleton width="s140" height="s8" />
        <Skeleton width="s140" height="s8" />
      </Box>
    </Box>
  )
}

const LoadingBlock = () => {
  return (
    <Box gap="s16" flexDirection="row" justifyContent="spaceBetween">
      <Skeleton width="s20" height="s20" />
      <Box
        flexGrow
        gap="s32"
        padding="s24"
        border={{
          all: {
            width: 's2',
            color: 'grey200',
            style: 'solid',
          },
        }}
        borderRadius={{
          all: 'abs008',
        }}
        height="full"
      >
        <Box flexDirection="row" justifyContent="spaceBetween">
          <Box gap="s8">
            <Skeleton width="s140" height="s8" />
            <Skeleton width="s80" height="s8" />
          </Box>
          <Skeleton width="s80" height="s24" />
        </Box>
        <LoadingItem />
        <LoadingItem />
        <LoadingItem />
      </Box>
    </Box>
  )
}

const LoadingHeader = () => {
  return (
    <Box gap="s4">
      <Skeleton width="s80" height="s8" />
      <Skeleton width="s120" height="s8" />
    </Box>
  )
}

const LoadingState = () => {
  return (
    <Box gap="s32" width="full">
      <LoadingHeader />
      <Box gap="s40">
        <LoadingBlock />
        <LoadingBlock />
        <LoadingBlock />
        <LoadingBlock />
        <LoadingBlock />
      </Box>
    </Box>
  )
}

export default LoadingState
